exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".posts .post-box .post-text {\n  color: #3E4B5B; }\n", ""]);

// exports
